// extracted by mini-css-extract-plugin
module.exports = {"theme":"#9b6a45"};